import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const ContactSection = () => {
  return (
    <Container fluid>
      <Container>
        <Row className="justify-content-center text-center py-60">
          <Col lg={12}>
            <h2 className="ft-20 text-tangaroa">Contacto</h2>
          </Col>
          <Col lg={12}>
            <i className="fas fa-envelope py-15 icon-medium text-dark-blue" />
            <h3 className="py-15 ft-18 text-midnight-blue">Correo</h3>
            <a href="mailto:experiencias.rewards@aeromexico.com" className="text-midnight-blue">experiencias.rewards@aeromexico.com</a>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default ContactSection;
